import React, { useEffect, useState } from "react";
import "./style.scss";
import * as Yup from "yup";
import { Button, Form, Modal } from "react-bootstrap";
import FileIcon from "../../../icons/FileIcon";
import AngleWhiteTopIcon from "../../../icons/AngleWhiteTopIcon";
import CrossWhiteBlackIcon from "../../../icons/CrossWhiteBlackIcon";
import { useNavigate } from "react-router-dom";
import TimerIcon from "../../../icons/TimerIcon";
import GroupUsersIcon from "../../../icons/GroupUsersIcon";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { addClass, deleteClassById, editClass } from "../../../services/classes.service";
import { getAllSubServices } from "../../../services/subServices.service";
import Select from 'react-select';
import moment from "moment";
import { MIME_TYPE_MAP } from "../../../constants/utlis";
import { useSelector } from "react-redux";
import ErrorText from "../error-text";
import PolicyModal from "../policyModal/PlicyModal";
import { AxiosError } from "axios";
import DeleteRedIcon from "../../../icons/DeleteRedIcon";

export default function ClassesTab(params: any) {
  const fileUrl = process.env.REACT_APP_FILE_URL;
  const [count, setCount] = useState(1);
  const [policyModal, setPolicyModal] = useState<any>(false)
  const [afterOccurencesCount, setAfterOccurencesCount] = useState(1)
  const [loading, setLoading] = useState(false);
  const [selectedDays, setSelectedDays] = useState<string[]>([]);
  const [images, setImages] = useState<File[]>([]);
  const [previews, setPreviews] = useState<string[]>([]);
  const user = useSelector((state: any) => state.user);
  const [servicelist, setServicelist] = useState<any[]>([]);
  const [startTime, setStartTime] = useState<any>('')
  const [endTime, setEndTime] = useState<any>('')
  const [subServicelist, setSubServicelist] = useState<any[]>([]);
  const [endTimeFormat, setEndTimeFormat] = useState<string>('');
  const [startTimeFormat, setStartTimeFormat] = useState<string>('');
  const navigate = useNavigate();
  const [selectedClassId, setSelectedClassId] = useState<string | null>(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const classInitialValues: any = {
    classStatus: (params?.classData?.classStatus == true),
    subServiceId: params?.classData?.subServiceId || null,
    className: params?.classData?.className || null,
    description: params?.classData?.description || "",
    bookingInstruction: params?.classData?.bookingInstruction || "",
    classStartDate: params?.classData?.classStartDate || null,
    classStartTime: params?.classData?.classStartTime || "",
    classEndTime: params?.classData?.classEndTime || "",
    classRepeatType: params?.classData?.classRepeatType || null,
    classRepeatCount: params?.classData?.classRepeatCount || 0,
    classSelection: params?.classData?.classSelection || "",
    classWeekdays: params?.classData?.classWeekdays || "",
    classEndType: params?.classData?.classEndType || "",
    classEndDate: params?.classData?.classEndDate || moment().add(1, "days").format("YYYY-MM-DD"),
    classEndOccurence: params?.classData?.classEndOccurence || 0,
    maxBooking: params?.classData?.maxBooking || null,
    images: params?.classData?.images || [],
    isDayPass: params?.classData?.isDayPass || false,
    bookingCutoffMinutes: params?.classData?.bookingCutoffMinutes ?? 0,
  };

  const classSchema: any = Yup.object().shape({
    classStatus: Yup.string().optional(),
    subServiceId: Yup.string().required("Field is required"),
    className: Yup.string().required("Field is required"),
    classStartDate: Yup.string().required("Field is required"),
    classStartTime: Yup.string().required("Field is required"),
    classEndTime: Yup.string().required("Field is required"),
    classWeekdays: Yup.string().required("Field is required"),
    classRepeatType: Yup.string().required("Field is required"),
    classEndType: Yup.string().required("Field is required"),
    maxBooking: Yup.number().required("Field is required")
  });

  const daysOfWeek = [
    { id: "everyday", name: "Everyday" },
    { id: "monday", name: "Monday" },
    { id: "tuesday", name: "Tuesday" },
    { id: "wednesday", name: "Wednesday" },
    { id: "thursday", name: "Thursday" },
    { id: "friday", name: "Friday" },
    { id: "saturday", name: "Saturday" },
    { id: "sunday", name: "Sunday" },
  ];

  const slotOptions = ["day", "week", "month"];

  useEffect(() => {
    getServices();
  }, [])

  useEffect(() => {
    // 
  }, [setStartTimeFormat, setEndTimeFormat])

  useEffect(() => {
    // Run initialization for both edit mode (_id exists) and duplicate mode (classData exists but no _id)
    const hasClassData = params?.classData && (params?.classData?._id || params?.classData?.className);
    
    if (hasClassData) {
      // Only set selectedClassId for edit mode (when _id exists)
    if (params?.classData?._id) {
        setSelectedClassId(params?.classData?._id);
      }

      // Initialize images
      if (params?.classData?.images && params?.classData?.images?.length > 0) {
        let previewImgArr: any = [];
        for (let item of params?.classData?.images) {
          const extension = item.split('.').pop().toLowerCase();
          let mimeType = MIME_TYPE_MAP[extension] || 'application/octet-stream';

          previewImgArr.push({
            preview: item,
            type: mimeType,
          })
        }
        setPreviews([...previewImgArr]);
        setImages([...params?.classData?.images]);
      }

      // Initialize subServiceId (category)
      if (params?.classData?.subServiceId) {
        let item: any = subServicelist.find(item => item._id == params?.classData?.subServiceId)
        if (item?._id) {
          formik.setFieldValue("subServiceId", item._id)
        } else {
          // If service not found in list yet, set it directly (list might load later)
          formik.setFieldValue("subServiceId", params?.classData?.subServiceId)
        }
      }

      // Initialize class repeat count
      if (params?.classData?.classRepeatCount || params?.classData?.classRepeat?.repeatCount) {
        let repeatCount = params?.classData?.classRepeatCount || params?.classData?.classRepeat?.repeatCount;
        let number = parseInt(repeatCount)
        if (!isNaN(number)) {
          setCount(number)
        }
      }

      // Initialize selected weekdays
      if (params?.classData?.selection) {
        const weekDays = params?.classData?.selection;
        if (weekDays.includes("everyday")) {
          setSelectedDays(["everyday"]);
        } else {
          setSelectedDays(weekDays);
        }
      } else if (params?.classData?.classRepeat?.weekDays && params?.classData?.classRepeat?.weekDays.length > 0) {
        // Also check classRepeat.weekDays for duplicate mode
        const weekDays = params?.classData?.classRepeat?.weekDays;
        if (weekDays.includes("everyday")) {
          setSelectedDays(["everyday"]);
        } else {
          setSelectedDays(weekDays);
        }
      }

      // Initialize class end occurrences
      if (params?.classData?.classEnd?.type == "after") {
        const occurrences = params?.classData?.classEnd?.NoOfOccurence || params?.classData?.classEndOccurence || 1;
        setAfterOccurencesCount(occurrences);
      }

      // Initialize class times
      if (params?.classData?.classTime?.start && params?.classData?.classTime?.end) {
        const amOrPmMorning = moment(params?.classData?.classTime?.start, 'HH:mm').format('A');
        const amOrPmEvening = moment(params?.classData?.classTime?.end, 'HH:mm').format('A');
        setStartTimeFormat(amOrPmMorning);
        setEndTimeFormat(amOrPmEvening);
        setStartTime(params?.classData?.classTime?.start);
        setEndTime(params?.classData?.classTime?.end);
      }

      // For duplicate mode: if start date is in the past, use today's date
      if (!params?.classData?._id && params?.classData?.classStartDate) {
        const startDate = moment(params?.classData?.classStartDate);
        if (startDate.isBefore(moment(), 'day')) {
          formik.setFieldValue("classStartDate", moment().format("YYYY-MM-DD"));
        }
      }
    }
  }, [params, subServicelist]);

  function increment(type = "repeat") {
    if (type == "end") {
      setAfterOccurencesCount(function (prevCount) {
        return (prevCount += 1);
      });
    } else {
      setCount(function (prevCount) {
        return (prevCount += 1);
      });
    }
  }

  function decrement(type = "repeat") {
    if (type == "end") {
      setAfterOccurencesCount(function (prevCount) {
        if (prevCount > 0) {
          return (prevCount -= 1);
        } else {
          return (prevCount = 0);
        }
      });
    }
    else {
      setCount(function (prevCount) {
        if (prevCount > 0) {
          return (prevCount -= 1);
        }
        else {
          return (prevCount = 0);
        }
      });
    }
  }

  const handleDayCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value, checked } = event.target;
    const updatedDays = checked
      ? [...selectedDays, value]
      : selectedDays.filter((day) => day !== value);

    if (value === "everyday" && checked) {
      setSelectedDays(["everyday"]);
    } else if (value === "everyday" && !checked) {
      setSelectedDays([]);
    } else {
      const filteredDays = updatedDays.filter((day) => day !== "everyday");
      setSelectedDays(filteredDays);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = Array.from(e.target.files || []);
    const selectedPreviews = selectedFiles.map((file) =>
    ({
      preview: URL.createObjectURL(file),
      type: file.type, // Save the MIME type
    }));

    setImages((prev) => [...prev, ...selectedFiles]);
    setPreviews((prev: any) => [...prev, ...selectedPreviews]);
  };

  const handleRemoveImage = (index: number) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handleServiceChange = (selectedOption: any) => {
    if (selectedOption?.value) {
      formik.setFieldValue("subServiceId", selectedOption.value);
    }
  };

  function isLiveUrl(filename: any) {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp', '.mp4', '.gif'];
    const extension = filename.slice(filename.lastIndexOf('.')).toLowerCase();
    if (imageExtensions.includes(extension)) {
      return true;
    } else {
      return false
    }
  }

  const formik: any = useFormik({
    initialValues: classInitialValues,
    validationSchema: classSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      // CRITICAL FIX: Use the selected location from localStorage instead of hardcoding to first location
      // This allows partners to create classes for any of their locations
      const selectedLocationId = localStorage.getItem('locationId');
      if (!selectedLocationId) {
        toast.error('Please select a location from the header dropdown before creating a class');
        setSubmitting(false);
        return;
      }
      values.partnerLocation = selectedLocationId;
      let classRepeat: any = {
        repeatCount: count,
      }
      let classEnd: any = {
      }
      let classTime: any = {
      }

      if (values.classRepeatType == "repeat") {
        classRepeat.type = "repeat";
      }
      if (values.classRepeatType == "doesNotRepeat") {
        classRepeat.type = "doesNotRepeat";
      }
      if (values.classWeekdays) {
        classRepeat.selection = values.classWeekdays;
        if (
          values.classWeekdays == "week" &&
          selectedDays &&
          selectedDays.length > 0
        ) {
          classRepeat.weekDays = selectedDays;
        }
      }

      if (values.classEndType) {
        classEnd.type = values.classEndType
        if (values.classEndType == "on") {
          if (values.classEndDate) {
            classEnd.date = values.classEndDate
          }
        }
        if (values.classEndType == "after") {
          classEnd.NoOfOccurence = afterOccurencesCount;
        }
      }

      if (values.classStartTime) {
        classTime.start = values.classStartTime
      }
      if (values.classEndTime) {
        classTime.end = values.classEndTime
      }
      if (values.classStartDate) {
        classTime.date = values.classStartDate
      }
      values.classRepeat = classRepeat;
      values.classEnd = classEnd;
      values.classTime = classTime;
      if (images && images.length > 0) values.images = images;
      const formData = new FormData();
      for (const key in values) {
        if (Array.isArray(values[key])) {
          values[key].forEach((item: any, index: any) => {
            if (typeof item === 'object' && item instanceof File) {
              formData.append(`${key}[${index}]`, item);
            } else {
              formData.append(`${key}[${index}]`, item);
            }
          });
        }
        else if (typeof values[key] === 'object' && values[key] instanceof File) {
          formData.append(key, values[key]);
        }
        else {
          if (typeof values[key] === 'object') {
            formData.append(key, JSON.stringify(values[key]));
          } else {
            formData.append(key, values[key]);
          }
        }
      }
      setLoading(true);
      try {
        if (params?.classData?._id) {
          const result = await editClass(params?.classData?._id, formData)
          if (result.data) {
            toast.success("Class updated successfully");
            navigate("/classes")
          }
        }
        else {
          const result = await addClass(formData);
          if (result.data) {
            toast.success("Class added successfully");
            navigate("/classes")
          }
        }
      } catch (error: any) {
        const msg = error?.response?.data?.responseMessage || "Something went wrong. Please try again.";
        toast.error(msg);
      } finally {
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  const getServices = async () => {
    try {
      const result = await getAllSubServices({});
      let array = result?.data?.data;
      if (Array.isArray(array) && array.length > 0) {
        array = array.map((item) => {
          return { ...item, value: item._id, label: item.name }
        })
        setSubServicelist(array)
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseModal = () => {
    setPolicyModal(false);
  };

  const handleDeleteClass = async (id: string) => {
    if (!id) return;
    setSelectedClassId(id)
    setDeleteModalShow(true);
  }

  const handleDeleteClose = () => {
    setDeleteModalShow(false);
  };

  const handleDeleteConfirm = async (selectedClassId: string | null) => {
    if (!selectedClassId) return;
    try {
      const result = await deleteClassById(selectedClassId);
      if (result?.data?.responseCode !== 200) {
        toast.error(result?.data?.responseMessage || "Failed to delete class");
        return;
      }
      toast.success(result?.data?.responseMessage);
      setDeleteModalShow(false);
      navigate("/classes");
    } catch (error: any) {
      const msg = error?.response?.data?.responseMessage || "Something went wrong. Please try again.";
      toast.error(msg);
    }
  }


  return (
    <div>

      <div>
        <Form onSubmit={formik.handleSubmit}>
          <div className="classesTabWrap">
            <div className="bgFormColor p-4 mb-3">
              <label>Class Information</label>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="statusCheck d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>Class Status</span>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        {...formik.getFieldProps("classStatus")}
                        checked={formik.values.classStatus == true}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <Select
                    name="service"
                    className="commonInput dropdownCustom"
                    options={subServicelist}
                    value={
                      subServicelist.find(
                        (option) => option.value === formik.values.subServiceId
                      ) || null
                    }
                    onChange={handleServiceChange}
                    placeholder="Select a service"
                  />
                  <ErrorText show={formik.touched.subServiceId && formik.errors.subServiceId} message={"Field is required"} />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label>Class Name</label>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <div className="group-img iconLeft  position-relative textareaWrap">
                      <Form.Control
                        className="commonInput"
                        type="text"
                        placeholder="Class name"
                        {...formik.getFieldProps("className")}
                      />
                      <ErrorText show={formik.touched.className && formik.errors.className} message={"Field is required"} />

                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <label>Description</label>
                  <div className="group-img iconLeft  position-relative textareaWrap">
                    <label>
                      <FileIcon />
                    </label>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Control
                        as="textarea"
                        rows={2}
                        placeholder="Tell us something about your class"
                        className="addressTextarea"
                        {...formik.getFieldProps("description")}
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>

              {/* Day Pass toggle and Booking Cutoff - Last row in Class Information */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="statusCheck d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>Day Pass</span>
                      <Form.Check
                        type="switch"
                        id="daypass-switch"
                        checked={formik.values.isDayPass === true}
                        onChange={(e) => {
                          formik.setFieldValue("isDayPass", e.target.checked);
                          if (e.target.checked) {
                            formik.setFieldValue("bookingCutoffMinutes", 0);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {!formik.values.isDayPass && (
                  <div className="col-md-6 mb-3">
                    <div className="group-img iconLeft rightLeft position-relative textareaWrap">
                      <label className="pt-3">
                        <TimerIcon />
                      </label>
                      <Form.Control
                        className="commonInput"
                        type="number"
                        min="0"
                        value={formik.values.bookingCutoffMinutes || ''}
                        onChange={(e) => {
                          formik.setFieldValue("bookingCutoffMinutes", e.target.value === '' ? 0 : parseInt(e.target.value) || 0);
                        }}
                        onBlur={formik.handleBlur}
                        name="bookingCutoffMinutes"
                        placeholder="Booking Restriction (minutes before class)"
                      />
                      <span className="person">| min</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="bgFormColor p-4 mb-3">
              <label><strong>Class start date</strong></label>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <div className="group-img iconLeft  position-relative textareaWrap">
                      <Form.Control
                        className="commonInput"
                        type="date"
                        placeholder="Class name"
                        {...formik.getFieldProps("classStartDate")}
                      />
                    </div>
                    <ErrorText show={formik.touched.classStartDate && formik.errors.classStartDate} message={"Field is required"} />

                  </Form.Group>
                </div>
              </div>
              <div className="wrap mt-3">
                <label><strong>Class timings</strong></label>
                <div className="row">
                  <div className="col-md-6">
                    <span>Class Start Time</span>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <div className="group-img iconLeft  position-relative textareaWrap">
                        <Form.Control
                          className="commonInput"
                          type="time"
                          placeholder="Class name"
                          {...formik.getFieldProps("classStartTime")}
                          onChange={(e) => {
                            let time = moment(e.target.value, 'HH:mm').format('A')
                            setStartTimeFormat(time)
                            setStartTime(e.target.value)
                            formik.setFieldValue(
                              "classStartTime",
                              e.target.value
                            );
                          }}
                        />
                        <ErrorText show={formik.touched.classStartTime && formik.errors.classStartTime} message={"Field is required"} />

                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <span>Class End Time</span>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <div className="group-img iconLeft  position-relative textareaWrap">
                        <Form.Control
                          className="commonInput"
                          type="time"
                          placeholder="Class name"
                          {...formik.getFieldProps("classEndTime")}
                          onChange={(e) => {
                            let time = moment(e.target.value, 'HH:mm').format('A')
                            setEndTimeFormat(time)
                            setEndTime(e.target.value)
                            formik.setFieldValue(
                              "classEndTime",
                              e.target.value
                            );
                          }}
                        />
                        <ErrorText show={formik.touched.classEndTime && formik.errors.classEndTime} message={"Field is required"} />

                      </div>
                    </Form.Group>
                  </div>
                </div>
              </div>
              <div className="wrap mt-3">
                <label>Class repeat</label>
                <div className="row align-items-end">
                  <div className="col-xl-4">
                    <div className="statusCheck d-flex justify-content-between align-items-center w-100 position-relative mb-2">
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <label className="mb-0 d-flex align-items-center">
                          <input
                            type="radio"
                            {...formik.getFieldProps("classRepeatType")}
                            checked={
                              formik.values.classRepeatType === "doesNotRepeat"
                            }
                            onChange={(e) => {
                              formik.setFieldValue(
                                "classRepeatType",
                                "doesNotRepeat"
                              );
                              formik.setFieldValue(
                                "classWeekdays",
                                "day"
                              );
                              setCount(0);
                              setSelectedDays([]);
                            }}
                          />
                          <span className="radioText">Does not repeat</span>
                          <span className="bgBlue"></span>
                        </label>
                      </div>
                    </div>
                    <div className="statusCheck d-flex justify-content-between align-items-center w-100 position-relative">
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <label className="mb-0 d-flex align-items-center">
                          <input
                            type="radio"
                            {...formik.getFieldProps("classRepeatType")}
                            checked={formik.values.classRepeatType === "repeat"}
                            onChange={(e) => {
                              formik.setFieldValue("classRepeatType", "repeat");
                            }}
                          />
                          <span className="radioText">Repeat every</span>
                          <span className="bgBlue"></span>
                          <div className="addOption">
                            <input value={count} />
                            <div className="btnsWrap">
                              <button
                                type="button"
                                onClick={() => increment("repeat")}
                              >
                                <AngleWhiteTopIcon />
                              </button>
                              <button
                                type="button"
                                className="rotate"
                                onClick={() => decrement("repeat")}
                              >
                                <AngleWhiteTopIcon />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-8">
                    {formik.values.classRepeatType != "doesNotRepeat" && (
                      <ul className="daysRadioBox">
                        {slotOptions.map((option) => (
                          <li key={option}>
                            <label>
                              <input
                                type="radio"
                                name="classWeekdays"
                                value={option}
                                onChange={(e) => {
                                  setSelectedDays(["everyday"]);
                                  formik.setFieldValue(
                                    "classWeekdays",
                                    e.target.value
                                  );
                                }}
                                checked={formik.values.classWeekdays === option}
                              />
                              <span className="day">{option}</span>
                              <span className="bg"></span>
                            </label>
                          </li>
                        ))}
                        {formik.touched.classWeekdays && formik.errors.classWeekdays && (
                          <p className="errorMessage mt-2">{"Field is required"}</p>
                        )}
                      </ul>
                    )}
                  </div>
                  <ErrorText show={formik.touched.classRepeatType && formik.errors.classRepeatType} message={"Class repeat is required field"} />
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    {formik?.values?.classWeekdays == "week" && (
                      <ul className="daysCheckbox">
                        {daysOfWeek.map((day) => (
                          <li key={day.id}>
                            <label>
                              <input
                                type="checkbox"
                                value={day.id}
                                checked={selectedDays.includes(day.id)}
                                onChange={handleDayCheckboxChange}
                              />
                              <span className="day">{day.name}</span>
                              <span className="bg"></span>
                            </label>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              <div className="wrap mt-3">
                <label>Class ends</label>
                <div className="row">
                  <div className="col-xl-4">
                    <div className="classEnd">
                      <div className="statusCheck d-flex justify-content-between align-items-center w-100 position-relative mb-2">
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <label className="mb-0 d-flex align-items-center">
                            <input
                              type="radio"
                              name="classEndType"
                              onChange={(e) => {
                                formik.setFieldValue("classEndType", "on");
                              }}
                              checked={formik.values.classEndType === "on"}
                            />
                            <span className="radioText">On</span>
                            <span className="bgBlue"></span>
                          </label>
                          <div className="dateShow">
                            <Form.Control
                              className="commonInput"
                              type="date"
                              placeholder="Class name"
                              {...formik.getFieldProps("classEndDate")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4">
                    <div className="classEnd">
                      <div className="statusCheck d-flex justify-content-between align-items-center w-100 position-relative mb-2">
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <label className="mb-0 d-flex align-items-center">
                            <input
                              type="radio"
                              name="classEndType"
                              onChange={(e) => {
                                formik.setFieldValue("classEndType", "after");
                              }}
                              checked={formik.values.classEndType === "after"}
                            />
                            <span className="radioText">After</span>
                            <span className="bgBlue"></span>
                            <div className="addOccurenceOption">
                              <input 
                                type="number"
                                min="1"
                                value={afterOccurencesCount} 
                                onChange={(e) => {
                                  const val = parseInt(e.target.value) || 1;
                                  setAfterOccurencesCount(val > 0 ? val : 1);
                                }}
                              />
                              <span className="occurrenceText">occurrences</span>
                              <div className="btnsWrap">
                                <button
                                  type="button"
                                  onClick={() => increment("end")}
                                >
                                  <AngleWhiteTopIcon />
                                </button>
                                <button
                                  type="button"
                                  className="rotate"
                                  onClick={() => decrement("end")}
                                >
                                  <AngleWhiteTopIcon />
                                </button>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ErrorText show={formik.touched.classEndType && formik.errors.classEndType} message={"Class Ends is required field"} />

                </div>
                <div className="row">
                </div>
                <ul className="addedTime my-3">
                  {(selectedDays.length > 0 || startTime != "") && (<li>
                    <TimerIcon />
                    <label>
                      <label>
                        {selectedDays?.join(", ") + (selectedDays.length > 0 ? " |" : "")} {" "}
                        {startTime} {startTimeFormat} {startTime != "" && endTime != "" ? " - " : ""}
                        {endTime} {endTimeFormat}
                      </label>
                    </label>
                  </li>)}
                </ul>
              </div>
            </div>
            <div className="bgFormColor p-4 mb-3">
              <label>Class capacity</label>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <div className="group-img iconLeft rightLeft  position-relative textareaWrap">
                      <label className="pt-3">
                        <GroupUsersIcon />
                      </label>
                      <Form.Control
                        className="commonInput"
                        type="text"
                        {...formik.getFieldProps("maxBooking")}
                      />
                      <span className="person">| person</span>
                    </div>
                    <ErrorText show={formik.touched.maxBooking && formik.errors.maxBooking} message={"Class Ends is required field"} />

                  </Form.Group>
                </div>
              </div>
            </div>
            <div className="bgFormColor p-4 mb-3">
              <label>Class images</label>
              <div className="uploadWrapper">
                <ul className="outerBlock">
                  <li>
                    <ul className="showImages">
                      {previews.map(({ preview, type }: any, index: any) => (
                        <li className="position-relative" key={index}>
                          <button
                            type="button"
                            className="crossBtn removeGymFile"
                            onClick={() => handleRemoveImage(index)}
                          >
                            <CrossWhiteBlackIcon />
                          </button>
                          <div className="image">
                            {type.startsWith("video") ? (
                              <video
                                src={
                                  isLiveUrl(preview) ? fileUrl + preview : preview
                                }
                                controls
                                className="w-100"
                              />
                            ) : (
                              <img
                                src={
                                  isLiveUrl(preview) ? fileUrl + preview : preview
                                }
                                alt={`Preview ${index}`}
                                className="w-100"
                              />
                            )}
                          </div>
                        </li>
                      ))}
                      <li className="uploadBlock">
                        <div className="upload text-center">
                          <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            accept="image/*,video/*"
                          />
                          <img
                            src={"/assets/img/uploadIcon.png"}
                            alt="uploadIcon"
                          />
                          <p>Drop or upload images</p>
                          <button>Browse image</button>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div className="d-flex flex-column align-items-start">
              <div className="row">
                <div className="col">
                  <button type="submit" className="saveBtn" disabled={loading}>
                    {loading ? "Saving..." : "Save class"}
                  </button>
                </div>

                <div className="col">
                  {selectedClassId && (
                    <button
                      type='button'
                      className='deleteClass'
                      onClick={() => handleDeleteClass(selectedClassId)}
                    >
                      {" "}
                      Delete Class
                    </button>
                  )}
                </div>
              </div>

              <span className="policyLink" onClick={() => setPolicyModal(true)} style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}>
                Read about our visitors class cancellation policy
              </span>
            </div>
          </div>
          <PolicyModal show={policyModal} handleClose={handleCloseModal} />
        </Form>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal show={deleteModalShow} onHide={handleDeleteClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className='delete-modal'
      >
        <Modal.Body className='text-center'>
          <div className='d-flex justify-content-center align-items-center'>
            <DeleteRedIcon />
          </div>
          <h3>Confirm Deletion</h3>
          <p>Are you sure you want to delete this class? This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline" onClick={handleDeleteClose}>Close</Button>
          <Button className='primaryButton' variant="primary" onClick={() => handleDeleteConfirm(selectedClassId)}>Continue</Button>
        </Modal.Footer>
      </Modal>
    </div>

  );
}
